import { GetHostDashboardDataQuery } from '@website/types/graphqlOperations';
import Link from 'next/link';
import {
  Accordion,
  Badge,
  Card,
  Col,
  Row,
  Alert,
  Button,
} from 'react-bootstrap';
import AddressFieldsView from '../utils/AddressFieldsView';
import SettingItemRow from '../utils/SettingItemRow';

interface HostPaymentDetailsProps {
  paymentInfo: GetHostDashboardDataQuery['hostByURL']['paymentDetails'];
  eventKey: string;
  urlSlug: string;
}

export function HostPaymentDetails({
  paymentInfo = undefined,
  eventKey = '2',
  urlSlug,
}: HostPaymentDetailsProps) {
  const isPaymentInfoAvailable =
    !!paymentInfo &&
    !!paymentInfo?.bankDetails &&
    !!paymentInfo?.bankDetails?.bankAddress;

  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>
        Payment Information{' '}
        {!isPaymentInfoAvailable && (
          <span className="fw-bold lead">
            <Badge pill bg="danger" className="ms-2">
              Incomplete
            </Badge>
          </span>
        )}
      </Accordion.Header>
      <Accordion.Body>
        <Card.Body>
          {paymentInfo && (
            <Row>
              <SettingItemRow
                fieldName="Preferred Currency"
                value={paymentInfo.currency ?? ''}
              />
            </Row>
          )}
          {paymentInfo?.bankDetails ? (
            <>
              <Row>
                <Col xs={12}>
                  <h4>Bank Details</h4>
                </Col>
              </Row>
              <Row>
                <SettingItemRow
                  fieldName="Bank Name"
                  value={paymentInfo.bankDetails?.bankName}
                />
                <SettingItemRow
                  fieldName="Bank Account Name"
                  value={paymentInfo.bankDetails?.bankAccountName}
                />
                <SettingItemRow
                  fieldName="Account Number"
                  value={paymentInfo.bankDetails?.accountNumber}
                />
                <SettingItemRow
                  fieldName="IBAN Number"
                  value={paymentInfo.bankDetails?.ibanNumber}
                />
                <SettingItemRow
                  fieldName="Swift / BIC Code"
                  value={paymentInfo.bankDetails?.swiftCode}
                />
                <SettingItemRow
                  fieldName="Sort Code"
                  value={paymentInfo.bankDetails?.sortCode}
                />
                <SettingItemRow
                  fieldName="Routing Code"
                  value={paymentInfo.bankDetails?.routingCode}
                />
              </Row>
              {paymentInfo?.bankDetails?.bankAddress && (
                <>
                  <Row>
                    <Col xs={12}>
                      <h5>Bank Address</h5>
                    </Col>
                  </Row>

                  <Row>
                    <AddressFieldsView
                      address={paymentInfo.bankDetails?.bankAddress}
                    />
                  </Row>
                </>
              )}
            </>
          ) : (
            <Alert variant="warning">
              We currently don't have your banking details
            </Alert>
          )}
          {!paymentInfo && (
            <Alert variant="warning">
              You haven't added payment information
            </Alert>
          )}
        </Card.Body>
        <Card.Body>
          <div className="d-grid gap-2">
            <Link
              href="/hosts/dashboard/[urlSlug]/edit/payments"
              as={`/hosts/dashboard/${urlSlug}/edit/payments`}
              passHref
              legacyBehavior
            >
              <Button role="button" variant="primary" size="lg">
                Update
              </Button>
            </Link>
          </div>
        </Card.Body>
      </Accordion.Body>
    </Accordion.Item>
  );
}
